import React from "react";

const LandingPageQuizQuestionBase = ({ yes, no, title, text, icon } = props) => {
	return (
		<div className="offers-landing-page-quiz-question-base ">
			<div>

        <p>{ text }</p>
        <h2>{ title }</h2>

				<div className="offers-landing-page-quiz-question-base__buttons">
					<button
						className="btn-green-md-s"
						onClick={step => {
							return yes(step);
						}}
					>
						SIM
					</button>
					<button
						className="btn-red-md-s"
						onClick={step => {
							return no(step);
						}}
					>
						NÃO
					</button>
				</div>
			</div>
			<img src="" className={`offers-lp-${icon}`} alt=""></img>
		</div>
	);
};

export default LandingPageQuizQuestionBase;
